'use strict';

// eslint-disable-next-line max-lines-per-function
angular.module('webAgro1App').directive('agroIconHistorico', function() {
  const TIPO_X_ICON = {
    stand: 'stand',
    produtividade: 'production',
    inseto: 'insects',
    invasora: 'invader',
    doenca: 'disease',
    nematoide: 'nematode',
    climatica: 'weather',
    solo: 'soil',
    manutencao_melhoria: 'repair',
    anotacao: 'note',
    recomendacao: 'recomendation',
    tarefa: 'task',
    aplicacao: 'pulverization-fill',
    recomendacao_semeadura: 'recomendation',
    aplicacao_semeadura: 'seeds',
    operacao_correcao_solo: 'correcao-solo',
    operacao_adubacao: 'fertilizer',
    recomendacao_operacao_correcao_solo: 'recomendation',
    recomendacao_operacao_adubacao: 'recomendation',
    semeadura_afericao: 'fa-calculator',
    colheita_afericao: 'fa-calculator',
    massa_seca_pastagem: 'dry-mass',
    medias_afericoes: 'fa-calculator',
    inimigo_natural: 'natural-enemy',
    aplicacao_afericao: 'fa-calculator',
    tratamento_semente: 'seedling'
  };

  return {
    restrict: 'A',
    scope: {
      historico: '='
    },
    link: function(scope, element) {
      const historico = scope.historico;

      let icon = TIPO_X_ICON[historico.tipo] || '';
      const isFontAwesome = icon.includes('fa-');
      if (isFontAwesome) {
        element.addClass('fa');
      } else {
        icon = `icon-${ icon}`;
      }

      element.addClass(icon);
    }
  };
});
